<template>
  <div class="btn btn-primary btn-lg btn-scoring-select">
    <input
        class="form-control score-select abstain-disable"
        :class="lockScores ? 'disabled' : ''"
        type="text"
        v-model="localScore"
        @input="$emit('update:score', $event.target.value)"
    >
    <span class="maximum">/ {{ maxScore }}</span>
  </div>
</template>

<script>
import ScoringControl from "./ScoringControl";

export default {
  extends: ScoringControl,
  data() {
    return {
      localScore: this.score
    };
  },
};
</script>
